import * as React from "react";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import DropdownApi from "../../../components/DropdownApi";
import { siteVehicleAdd, siteVehicleUpdate } from "../../../service/siteService";
import { Grid } from "@mui/material";
import { useToast } from "../../../context/ToastContext";
import { useSiteContext } from "../../../context/siteContext";
import useApiService from "../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { Column } from "primereact/column";
import { Vehicle } from "../../../models/vehicle.interface";
import { Equipment } from "../../../models/equipment.interface";
import { CancelIcon, CheckIcon } from "../../../assets/icons";
import { formatCurrency } from "../../../utils/currenctUtils";

export default function SiteVehicleAdd(modalProps: any) {
  const { site, setSite } = useSiteContext();

  const toast = useToast();
  const [vehicleData, setVehicleData] = useState<Vehicle[]>([]);
  const [selectedVehicles, setSelectedVehicles] = useState<Vehicle[]>([]);
  const [rowClick, __] = useState(true);

  function handleSelectionChange(e: any) {
    setSelectedVehicles(e.value as Vehicle[]);
  }

  const { loading: loadingVehicles } = useApiService<Vehicle[]>({
    url: "vehicle",
    method: "GET",
    apiName: "core",
    onSuccess: data => {
      const availableVehicles = data.filter(
        vehicle => !modalProps?.vehicleIds.includes(vehicle.id)
      );
      setVehicleData(availableVehicles);
    },
  });

  const { loading: addingVehicle, fetchData: addVehicle } = useApiService<
    {
      active: boolean;
      vehicle: string;
      id: number;
      site: string;
    }[]
  >({
    fetchOnMount: false,
    url: "site-vehicle",
    method: "POST",
    apiName: "core",
    onSuccess: data => {
      toast("success", "Vehicle Added Successfully");
      modalProps.setReload?.(!modalProps.reload);
      modalProps.setVisible?.(false);
    },
    onError: error => {
      toast("error", error.message || "Error adding vehicle");
    },
  });

  async function handleSave(selectedData: Vehicle[]) {
    const payload: { vehicle: string[] } = {
      vehicle: selectedData.map(vehicle => vehicle.id),
    };
    await addVehicle({
      payload: payload,
    });
  }

  const renderActiveStatus = (row: Equipment) => {
    if (row.active) {
      return <CheckIcon fill={"#2DD36FFF"} />;
    }
    return <CancelIcon fill={"#EB445AFF"} />;
  };

  const renderPrice = (row: Vehicle) => {
    return formatCurrency(row.price, true);
  };

  return (
    <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, overflowY: "auto", padding: "0 1rem 1rem" }}>
        <DataTable
          value={vehicleData ?? []}
          selectionMode={rowClick ? "multiple" : null}
          selection={selectedVehicles}
          onSelectionChange={(e: any) => {
            handleSelectionChange(e);
          }}
          dataKey={"id"}
          tableStyle={{ minWidth: "50rem" }}
          loading={loadingVehicles}
        >
          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
          <Column header={"Name"} field={"name"} style={{ minWidth: "12rem" }} />
          <Column header={"Description"} field={"description"} />
          <Column header={"Type"} field={"type"} />
          <Column header={"Active"} field={"active"} body={renderActiveStatus} />
          <Column header={"Price"} field={"price"} body={renderPrice} />
        </DataTable>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          gap: "1rem",
          background: "white",
          paddingTop: "1rem",
          borderTop: "1px solid #e5e7eb",
          flexShrink: 0,
        }}
      >
        <Button
          label="Cancel"
          severity="secondary"
          outlined
          onClick={() => {
            modalProps.setVisible?.(false);
          }}
          disabled={addingVehicle}
        />

        <Button
          label={"Add Equipment"}
          color={"primary"}
          loading={addingVehicle}
          disabled={addingVehicle || loadingVehicles}
          onClick={async () => {
            await handleSave(selectedVehicles);
          }}
        />
      </div>
    </div>
  );
}
